<template>
  <generic-modal :title="$t('property type')" ref="generic_modal">
    <form @submit.prevent="save">
      <div class="field">
        <label class="label">{{ $t("name") }}</label>
        <div class="control">
          <input
            class="input"
            type="text"
            v-model="meta.name"
            :placeholder="$t('property type name')"
            required
            maxlength="100"
          />
        </div>
      </div>

      <div class="field">
        <label class="label">{{ $t("description") }}</label>
        <div class="control">
          <textarea
            class="textarea"
            v-model="meta.description"
            :placeholder="$t('property type description')"
            rows="3"
            maxlength="500"
          ></textarea>
        </div>
      </div>

      <div class="field">
        <label class="label">{{ $t("status") }}</label>
        <div class="control">
          <div class="select is-fullwidth">
            <select v-model="meta.status">
              <option value="active">{{ $t("active") }}</option>
              <option value="inactive">{{ $t("inactive") }}</option>
            </select>
          </div>
        </div>
      </div>
    </form>

    <!-- Error handling -->
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>

    <!-- Footer with v-slot:footer pattern -->
    <template v-slot:footer>
      <button
        class="button is-success"
        @click="save"
        :disabled="is_form_invalid"
        :class="{ 'is-loading': saving }"
      >
        <span class="icon"><i class="fa fa-save"></i></span>
        <span>{{ $t("save") }}</span>
      </button>
      <button
        class="button is-danger"
        @click="remove"
        v-if="meta.uuid"
        :disabled="saving"
      >
        <span class="icon"><i class="fa fa-trash"></i></span>
        <span>{{ $t("delete") }}</span>
      </button>
      <button class="button" @click="close_modal" :disabled="saving">
        <span class="icon"><i class="fa fa-close"></i></span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>

<script>
import {
  put,
  post,
  del,
  get,
  generate_error_message_text,
  confirm_deletion_dialog,
  success_message,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "PropertyTypeModal",
  components: {
    GenericModal,
  },
  data() {
    return {
      meta: {
        name: "",
        description: "",
        status: "active",
        uuid: null,
      },
      error: "",
      saving: false,
      entity_uuid: "",
    };
  },
  computed: {
    is_form_invalid() {
      return !this.meta.name || this.meta.name.trim().length === 0;
    },
  },
  methods: {
    show_modal(uuid = null) {
      let v = this;
      v.set_initial_state();
      v.entity_uuid = uuid;

      if (uuid) {
        v.get_property_type(uuid);
      }

      v.$refs.generic_modal.show_modal();
    },

    close_modal() {
      this.$refs.generic_modal.close_modal();
      this.set_initial_state();
    },

    get_property_type(uuid) {
      let v = this;
      get("/appraisal/property-type", { uuid })
        .then((property_type) => {
          v.meta = { ...v.meta, ...property_type };
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },

    save() {
      let v = this;
      if (v.is_form_invalid) return;

      v.saving = true;
      v.error = "";

      // Trim whitespace
      v.meta.name = v.meta.name.trim();
      if (v.meta.description) {
        v.meta.description = v.meta.description.trim();
      }

      const isEdit = !!v.entity_uuid;
      const method = isEdit ? post : put;
      const endpoint = "/appraisal/property-type";

      method(endpoint, v.meta)
        .then(() => {
          success_message(v.$t("property type saved successfully"));
          v.$emit("success");
          v.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.saving = false;
        });
    },

    remove() {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure delete property type"),
        v,
        () => {
          del("/appraisal/property-type", { uuid: v.meta.uuid })
            .then(() => {
              success_message(v.$t("property type deleted successfully"));
              v.$emit("success");
              v.close_modal();
            })
            .catch((error) => {
              v.error = generate_error_message_text(error);
            });
        }
      );
    },

    set_initial_state() {
      this.meta = {
        name: "",
        description: "",
        status: "active",
        uuid: null,
      };
      this.error = "";
      this.saving = false;
      this.entity_uuid = "";
    },
  },
};
</script>

<style scoped>
.textarea {
  resize: vertical;
  min-height: 100px;
}
</style>
